module.exports = __webpack_public_path__ + "web/img/level-4.d991ea9e.png";